import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "checkbox",
    "preview",
    "targetPrice",
    "startDate",
    "billingInterval",
    "nextBillDate",
  ]

  connect() {
    this.calculateCredit()
  }

  calculateCredit() {
    if (this.checkboxTarget.checked && Number(this.targetPriceTarget.value) >= 0) {
      const frame =
        this.previewTarget.querySelector("turbo-frame") || document.createElement("turbo-frame")
      frame.setAttribute("id", "proration-preview")
      frame.setAttribute("data-action", "turbo:frame-load->proration-preview#handleFrameLoad")
      frame.setAttribute(
        "src",
        `proration_preview${window.location.search}&date=${this.startDateTarget.value}&billing_interval_id=${this.billingIntervalTarget.value}&target_price=${this.targetPriceTarget.value}${this.customInvoiceItemParams()}`
      )
      this.previewTarget.appendChild(frame)
    }
  }

  // The checked custom invoice item add-ons, so the previewed first invoice
  // prices them alongside the prorated lease charge.
  customInvoiceItemParams() {
    const name = "create_lease[custom_invoice_item_selections][]"
    return Array.from(this.element.querySelectorAll(`input[name="${name}"]:checked`))
      .map((input) => `&${encodeURIComponent(name)}=${encodeURIComponent(input.value)}`)
      .join("")
  }

  handleFrameLoad(event) {
    const nextDueDateEl = event.target.querySelector("[data-next-due-date]")
    if (nextDueDateEl) {
      this.nextBillDateTarget.disabled = true
      this.nextBillDateTarget.title = "You cannot change the next bill date when prorating"
      this.nextBillDateTarget.value = nextDueDateEl.dataset.nextDueDate
    } else {
      this.checkboxTarget.checked = false
    }
  }

  showCredit(e) {
    if (this.checkboxTarget.checked) {
      this.calculateCredit()
    } else {
      this.previewTarget.innerHTML = ""
      document.querySelector("#create_lease_next_bill_date").disabled = false
    }
  }
}
